import { Bot, FileText, Languages, ShoppingCart, Cloud, Code2, Cpu, Sparkles, Users, TrendingUp, Shield, Globe, Zap, Layers, Database, Server, Brain, Workflow, Target, Award, Building2, BookOpen, HeartPulse, Mic } from 'lucide-react';

// ============================================
// HIMACHAL PRADESH NATURE IMAGES (Page Backgrounds)
// ============================================
export const natureImages = {
  // SNOW-CAPPED MOUNTAINS
  manaliSnow: "https://images.unsplash.com/photo-1711943729014-396f093d0fb5?w=1920&q=90",
  manaliRange: "https://images.unsplash.com/photo-1711943728995-f8cbcd6ebb69?w=1920&q=90",
  dhauladharRange: "https://images.unsplash.com/photo-1626808642875-0aa545482dfb?q=90&w=1920&auto=format&fit=crop",
  dhauladharGreen: "https://images.unsplash.com/photo-1627625335607-60187d590493?w=1920&q=90",
  himalayanSnow: "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=1920&q=90",
  kulluValley: "https://images.unsplash.com/photo-1615552714321-dca9935c0981?w=1920&q=90",
  blueHills: "https://images.unsplash.com/photo-1621505697693-9784907b50c9?w=1920&q=90",
  // CINEMATIC GOLDEN HOUR - Primary hero background
  cinematicHimalaya: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=90&w=2400&auto=format&fit=crop",
  goldenHourPeaks: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=90&w=2400&auto=format&fit=crop",
  snowPeaksSunset: "https://images.unsplash.com/photo-1519904981063-b0cf448d479e?q=90&w=2400&auto=format&fit=crop",
  
  // BUILDINGS & ARCHITECTURE
  shimlaMunicipal: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=1920&q=90",
  shimlaLandscape: "https://images.unsplash.com/photo-1593696140826-c58b021acf8b?w=1920&q=90",
  dharamshalaValley: "https://images.unsplash.com/photo-1626808642895-77d0ee7f9421?w=1920&q=90",
  natureLandscape: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=90",
  
  // RIVERS
  riverRocks: "https://images.unsplash.com/photo-1655470062301-e813948e9874?w=1920&q=90",
  riverForest: "https://images.unsplash.com/photo-1611523658822-385aa008324c?w=1920&q=90",
  riverMountain: "https://images.unsplash.com/photo-1715236041029-b1ae4aff390d?w=1920&q=90",
  riverValley: "https://images.unsplash.com/photo-1624697561550-982f5d50f97d?w=1920&q=90",
  
  // FORESTS
  deodarForest: "https://images.unsplash.com/photo-1633138922511-4276f61b5a61?w=1920&q=90",
  pineForest: "https://images.unsplash.com/photo-1598979348399-d9812608afc0?w=1920&q=90",
  cedarForest: "https://images.unsplash.com/photo-1720680720969-59abdf3b8483?w=1920&q=90",
  mistyForest: "https://images.unsplash.com/photo-1595995518298-5df716362207?w=1920&q=90",
  greenValley: "https://images.unsplash.com/photo-1614095431374-c5e71970d70c?w=1920&q=90"
};

// ============================================
// AI/TECH IMAGES (Small Card Accents Only)
// ============================================
export const techImages = {
  robotYellow: "https://images.unsplash.com/photo-1767955006100-cf73d990599f?w=400&q=85",
  robotOrange: "https://images.unsplash.com/photo-1768400730810-5c4398d58ae7?w=400&q=85",
  robotTwins: "https://images.unsplash.com/photo-1768400730812-039f5971185d?w=400&q=85",
  serverGreen: "https://images.unsplash.com/photo-1680992046626-418f7e910589?w=400&q=85",
  circuitBlue: "https://images.unsplash.com/photo-1731400800900-1bce57414c09?w=400&q=85",
  aiBrain: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=400&q=85",
  codeScreen: "https://images.unsplash.com/photo-1759661881353-5b9cc55e1cf4?w=400&q=85"
};

// Combined for backward compatibility
export const images = { ...natureImages, ...techImages };

// Tech Stack with actual logo URLs
export const techStack = {
  frontend: [
    { name: "React 18", description: "Main frontend application framework", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
    { name: "TypeScript", description: "Typed frontend development", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
    { name: "Vite", description: "Fast frontend build tooling", category: "Frontend", logo: "https://vitejs.dev/logo.svg" },
    { name: "Astro 6", description: "Static site framework for content-focused websites", category: "Frontend", logo: "https://astro.build/assets/press/astro-icon-light-gradient.svg" },
    { name: "Astro Components", description: "Component-based static site development", category: "Frontend", logo: "https://astro.build/assets/press/astro-icon-light-gradient.svg" },
    { name: "Astro Assets", description: "Optimized image pipeline for static websites", category: "Frontend", logo: "https://astro.build/assets/press/astro-icon-light-gradient.svg" },
    { name: "React Router", description: "Client-side routing with react-router-dom", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/reactrouter/reactrouter-original.svg" },
    { name: "Radix UI", description: "Accessible UI component primitives", category: "Frontend", logo: "https://avatars.githubusercontent.com/u/75042455?s=200&v=4" },
    { name: "CSS", description: "Global CSS and component-scoped styles", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
    { name: "Tailwind CSS", description: "Utility-first styling system", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg" },
    { name: "Recharts", description: "Charts and data visualization", category: "Frontend", logo: "" },
    { name: "React Hook Form", description: "Form state management", category: "Frontend", logo: "" },
    { name: "Zod", description: "Schema validation for forms and data", category: "Frontend", logo: "" },
    { name: "Zustand", description: "Lightweight client-side state management", category: "Frontend", logo: "" },
    { name: "TanStack React Query", description: "Server-state and data-fetching layer", category: "Frontend", logo: "" },
    { name: "Framer Motion", description: "Animation library for React interfaces", category: "Frontend", logo: "" },
    { name: "lucide-react", description: "Icon system for React applications", category: "Frontend", logo: "" },
    { name: "Three.js", description: "3D rendering for product visuals", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/threejs/threejs-original.svg" },
    { name: "React Three Fiber", description: "React renderer for Three.js scenes", category: "Frontend", logo: "" },
    { name: "@react-three/drei", description: "Helpers for React Three Fiber scenes", category: "Frontend", logo: "" },
    { name: "Leaflet", description: "Interactive map rendering", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/leaflet/leaflet-original.svg" },
    { name: "react-leaflet", description: "React integration for Leaflet maps", category: "Frontend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/leaflet/leaflet-original.svg" },
    { name: "jsPDF", description: "Client-side PDF generation", category: "Frontend", logo: "" },
    { name: "html2canvas", description: "DOM-to-canvas capture for exports", category: "Frontend", logo: "" },
    { name: "JSZip", description: "Client-side ZIP archive generation", category: "Frontend", logo: "" },
    { name: "html5-qrcode", description: "QR code scanning in the browser", category: "Frontend", logo: "" },
    { name: "JsBarcode", description: "Barcode generation for web apps", category: "Frontend", logo: "" },
    { name: "Sonner", description: "Toast notifications", category: "Frontend", logo: "" },
    { name: "i18next", description: "Internationalization framework", category: "Frontend", logo: "" },
    { name: "react-i18next", description: "React bindings for i18next", category: "Frontend", logo: "" }
  ],
  backend: [
    { name: "FastAPI", description: "Python microservice API framework", category: "Backend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/fastapi/fastapi-original.svg" },
    { name: "Uvicorn", description: "ASGI server for Python services", category: "Backend", logo: "" },
    { name: "Supabase", description: "Backend, database, and auth platform", category: "Backend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg" },
    { name: "Supabase Edge Functions", description: "Serverless functions for backend workflows", category: "Backend", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg" }
  ],
  dataInfra: [
    { name: "PostgreSQL", description: "Primary relational database", category: "Data / Infra", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
    { name: "SQLAlchemy", description: "Python database ORM and query layer", category: "Data / Infra", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlalchemy/sqlalchemy-original.svg" },
    { name: "asyncpg / psycopg2", description: "PostgreSQL drivers for async and sync workloads", category: "Data / Infra", logo: "" },
    { name: "Redis", description: "Queues, pub/sub, cache, and session state", category: "Data / Infra", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" },
    { name: "Docker", description: "Containerized service deployment", category: "Data / Infra", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
    { name: "Railway", description: "Deployment configuration and hosting workflow", category: "Data / Infra", logo: "https://railway.app/brand/logo-light.svg" },
    { name: "Cloudflare Pages", description: "Static website deployment platform", category: "Data / Infra", logo: "https://www.cloudflare.com/favicon.ico" },
    { name: "Cloudflare Workers", description: "Serverless edge runtime", category: "Data / Infra", logo: "https://www.cloudflare.com/favicon.ico" },
    { name: "Wrangler", description: "Cloudflare deployment CLI", category: "Data / Infra", logo: "https://www.cloudflare.com/favicon.ico" },
    { name: "Node.js", description: "JavaScript build runtime", category: "Data / Infra", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
    { name: "npm", description: "Package manager and build scripts", category: "Data / Infra", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg" },
    { name: "GitHub", description: "Source control and repository hosting", category: "Data / Infra", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
    { name: "OpenTelemetry", description: "Distributed tracing and observability", category: "Data / Infra", logo: "https://opentelemetry.io/img/logos/opentelemetry-logo-nav.png" },
    { name: "structlog", description: "Structured Python application logging", category: "Data / Infra", logo: "" }
  ],
  contentSeo: [
    { name: "Static Site Generation", description: "Pre-rendered pages for fast content websites", category: "Content / SEO", logo: "" },
    { name: "Pagefind", description: "Static site search with default UI", category: "Content / SEO", logo: "" },
    { name: "WordPress REST API", description: "Build-time content fetching", category: "Content / SEO", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg" },
    { name: "WordPress CMS", description: "Blog and content management", category: "Content / SEO", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg" },
    { name: "JSON-LD Schema", description: "Structured data for SEO", category: "Content / SEO", logo: "" },
    { name: "@astrojs/sitemap", description: "Sitemap generation for Astro sites", category: "Content / SEO", logo: "https://astro.build/assets/press/astro-icon-light-gradient.svg" },
    { name: "Meta Tags", description: "Page-level SEO metadata", category: "Content / SEO", logo: "" }
  ],
  aiRag: [
    { name: "Google Gemini", description: "Chat model via google-genai", category: "AI / RAG", logo: "https://upload.wikimedia.org/wikipedia/commons/8/8a/Google_Gemini_logo.svg" },
    { name: "Pydantic AI", description: "Agent framework for typed AI workflows", category: "AI / RAG", logo: "https://avatars.githubusercontent.com/u/110818415?s=200&v=4" },
    { name: "OpenAI Embeddings", description: "Embeddings for retrieval workflows", category: "AI / RAG", logo: "https://cdn.worldvectorlogo.com/logos/openai-2.svg" },
    { name: "pgvector-style Search", description: "Vector retrieval with hybrid search", category: "AI / RAG", logo: "" },
    { name: "FlashRank", description: "Reranking for retrieval quality", category: "AI / RAG", logo: "" },
    { name: "LLMLingua", description: "Context compression for RAG prompts", category: "AI / RAG", logo: "" }
  ],
  documentOcr: [
    { name: "Kreuzberg", description: "Document and OCR extraction toolkit", category: "Document / OCR", logo: "" }
  ]
};

export const companyInfo = {
  name: "Globistaan",
  fullName: "Globistaan Technologies and Exports Private Limited",
  tagline: "AI-Powered Solutions from the Himalayas",
  subtitle: "We transform businesses with cutting-edge artificial intelligence and scalable SaaS platforms — built from the mountains of Himachal Pradesh, India, for the world.",
  founded: "2023",
  incorporationDate: "Sept 27, 2023",
  incorporationDateShort: "Incorporated Sept 27, 2023",
  location: "Village Narghor (Chobu), Post Office Nagehar, Baijnath, Kangra, Himachal Pradesh 176128",
  xHandle: "@globistaan",
  founderExperience: "13+ years",
  email: "ceo@globistaan.com",
  phone: "+91 8291486041",
  website: "www.globistaan.com"
};

export const registrations = [
  { title: "Private Limited Company", description: "Government registered, MCA approved company", icon: Building2 },
  { title: "GST Compliant", description: "Registered with Goods and Services Tax from inception", icon: Shield },
  { title: "Registered MSME", description: "Recognized Micro, Small and Medium Enterprise on Udyam portal", icon: Award },
  { title: "DGFT Compliant", description: "Registered on Directorate General of Foreign Trade with IEC code", icon: Globe },
  { title: "DPIIT Registered", description: "Registered with Department for Promotion of Industry and Internal Trade", icon: Target }
];

export const projects = [
  {
    id: "ai-chatbot",
    logo: "/images/projects/dailogue.png",
    logoBg: "#070A12",
    title: "dAIlogue - AI Chatbot Platform",
    description: "Next-generation conversational AI platform that understands context, sentiment, and intent. Built for enterprise customer support, sales automation, and internal operations.",
    features: ["Multi-language support", "Context-aware responses", "Custom training pipelines", "Analytics dashboard", "API integrations"],
    status: "Live",
    website: "https://www.dailogue.io/",
    demoVideo: "https://demo.arcade.software/video/IBey5cVTXrvgyiTpKPue?embed&autoplay=true&muted=true&mute=true&playsinline=true",
    accentClass: "accent-purple",
    icon: Bot,
    category: "AI as a Service",
    partnership: "A product of Globistaan Technologies and Exports Private Limited, built in partnership with industry experts."
  },
  {
    id: "krishlav",
    logo: "/images/projects/krishlav.png",
    logoBg: "#FFFFFF",
    title: "KrishLav - AI Teaching Companion",
    tagline: "Make Knowledge Your Friend",
    description: "A teaching companion built for teachers. Run a spoken AI tutor with your class in any Indian language, bring question papers to life, and open windows into other classrooms. Students take part only with their teacher in the room, so the classroom stays teacher-led while every child gets a patient, multilingual tutor.",
    features: ["Built for teachers", "Spoken AI tutor in class", "22 Indian languages", "Question papers brought to life", "Windows into other classrooms", "Teacher login & workspace"],
    status: "Demo",
    website: "https://krishlav.com/",
    accentClass: "accent-green",
    icon: BookOpen,
    category: "AI as a Service",
    partnership: "A project developed and operated by Globistaan Technologies and Exports Private Limited."
  },
  {
    id: "ai-pharma",
    logo: "/images/projects/aytan-ai.jpg",
    logoBg: "#FFFFFF",
    title: "AI Pharma Document Generation",
    description: "Intelligent document generation system for pharmaceutical companies. Automates regulatory submissions, clinical trial reports, and compliance documentation with AI precision.",
    features: ["Regulatory compliance", "Template management", "AI-powered drafting", "Version control", "Audit trails"],
    status: "In Development",
    website: "https://aytanai.com/",
    demoVideo: "https://demo.arcade.software/video/bHXj6MbshFn00lBa0urm?embed&autoplay=true&muted=true&mute=true&playsinline=true",
    accentClass: "accent-blue",
    icon: FileText,
    category: "AI as a Service",
    partnership: "Built in partnership with pharma industry experts"
  },
  {
    id: "ai-language",
    title: "AI Language Learning App",
    description: "Personalized language learning powered by AI. Adaptive curriculum, real-time pronunciation feedback, and immersive conversation practice with AI tutors.",
    features: ["Adaptive learning paths", "Speech recognition", "AI conversation partner", "Progress tracking", "Gamification"],
    status: "In Development",
    accentClass: "accent-orange",
    icon: Languages,
    category: "AI as a Service",
    partnership: "Built in partnership with education industry experts"
  },
  {
    id: "saas-ecommerce",
    logo: "/images/projects/balaji-print-media.png",
    logoBg: "#FFFFFF",
    title: "SaaS E-Commerce Platform",
    description: "A focused e-commerce app platform for individual shopkeepers and business owners, with product catalog management, inventory operations, order workflows, and analytics for each standalone online store.",
    features: ["Single-store setup", "Product catalog management", "Inventory operations", "Order workflows", "Analytics & insights"],
    status: "Live",
    website: "https://shop.balajiprintmedia.com/",
    accentClass: "accent-pink",
    icon: ShoppingCart,
    category: "SaaS Platform",
    partnership: "Built in partnership with e-commerce experts"
  },
  {
    id: "dr-nisharg-gastro",
    logo: "/images/projects/dr-nisharg-patel.png",
    logoBg: "#FFFFFF",
    title: "Gastroenterologist Website",
    description: "A live healthcare website for a Surat-based gastroenterologist and liver specialist, built with Astro 6 and Codex and hosted by Globistaan.",
    features: ["Astro 6 build", "Codex-assisted development", "Healthcare content structure", "Responsive website", "Hosting support"],
    status: "Live",
    website: "https://drnishargpatelgastro.com/",
    accentClass: "accent-green",
    icon: HeartPulse,
    category: "SaaS Platform",
    partnership: "Web design and SEO by Dr Nisharg Patel's design team; web development and hosting by Globistaan"
  },
  {
    id: "sri-krishna-art",
    logo: "/images/projects/sri-krishna-art.jpg",
    logoBg: "#FFFFFF",
    title: "Sri Krishna Art Website",
    description: "A refined artist portfolio and online-class platform for Greeshma Bhat, a Bengaluru-based artist and drawing teacher. The site presents original artworks, commission enquiries, online class enrolment, social proof, and an immersive wall-preview experience.",
    features: ["Artist portfolio", "AR wall preview", "Class enrolment", "Commission enquiries", "SEO schema"],
    status: "Live",
    accentClass: "accent-green",
    icon: Sparkles,
    category: "Client Work",
    partnership: "Designed, developed, and maintained by Globistaan for Sri Krishna Art.",
    website: "https://srikrishnaartt.com/"
  }
];

export const services = [
  { title: "AI-Enabled App Development", description: "Business applications with useful AI-assisted workflows, automation, and integrations.", icon: Brain },
  { title: "SaaS Platform Engineering", description: "Scalable SaaS platforms and standalone business apps built with modern cloud-native architecture.", icon: Layers },
  { title: "Intelligent Automation", description: "Automate complex business workflows with AI-driven decision-making systems.", icon: Workflow },
  { title: "Data Engineering & Analytics", description: "End-to-end data pipelines, warehousing, and AI-powered analytics dashboards.", icon: Database },
  { title: "Cloud Infrastructure", description: "Cloud-native deployments on AWS, Railway, and hybrid architectures for optimal performance.", icon: Cloud },
  { title: "Enterprise Integration", description: "Seamless integration of AI capabilities into existing enterprise systems and workflows.", icon: Zap }
];

export const directors = [
  { name: "Bejoy Pramanick", role: "Founder CEO", bio: "Experienced Java developer and team lead with international exposure in the US and project management experience across international banking technology programs.", avatar: "/images/founders/bejoy-pramanick.jpg", avatarPosition: "42% center" },
  { name: "Yoginder Singh", role: "Co-Founder", bio: "Retired CRPF professional with experience across multiple Indian states and hands-on team management experience in the hospitality sector in Baijnath, Himachal Pradesh.", avatar: "/images/founders/yoginder-singh.png", avatarPosition: "center 35%" }
];

export const developers = [
  { name: "Sahil", role: "Full Stack Developer", bio: "Freelance full stack developer working on AI Pharma Document Generation and AI Language Learning App, with support across frontend, backend, and integrations.", avatar: "/images/freelancer-sahil.png" },
  { name: "Shagun", role: "Business Development Freelancer", bio: "Freelance business development partner for Globistaan Technologies and Exports Private Limited, focused on client outreach, partnerships, and growing the pipeline for our AI products and services.", avatar: "/images/freelancer-shagun.png" }
];

export const logoDesigners = [
  {
    name: "Jai Dogra",
    role: "Freelance Logo Designer",
    bio: "Designed the Globistaan company logo, giving the brand a distinct and memorable visual identity.",
    avatar: "/images/designers/jay-kumar.jpg",
    portfolio: "https://www.behance.net/jaikumar35"
  }
];

export const clients = [
  {
    name: "Aytan AI",
    logo: "/images/projects/aytan-ai.jpg",
    industry: "Healthcare / Pharma",
    contact: "Mr. Punit Panjwani",
    location: "Rhode Island, USA",
    relationship: "Product Owner",
    website: "https://aytanai.com/",
    demoVideo: "https://demo.arcade.software/video/bHXj6MbshFn00lBa0urm?embed&autoplay=true&muted=true&mute=true&playsinline=true",
    image: "/images/clients/punit.png",
    imagePosition: "center 28%",
    testimonial: "PharmaGen AI is an AI-assisted platform for pharmaceutical document drafting, review, and workflow coordination.",
    highlights: ["PharmaGen AI", "Document drafting", "Review workflows"],
    avatar: null
  },
  {
    name: "dAIlogue",
    logo: "/images/projects/dailogue.png",
    industry: "AI Conversation Assistant",
    contact: "Mr. Vivek Pramanick",
    location: "Stockholm, Sweden",
    relationship: "Product Partner",
    website: "https://www.dailogue.io/",
    demoVideo: "https://demo.arcade.software/video/IBey5cVTXrvgyiTpKPue?embed&autoplay=true&muted=true&mute=true&playsinline=true",
    image: "/images/clients/vivek.png",
    imagePosition: "center 24%",
    testimonial: "dAIlogue is an AI-powered conversation assistant that supports chatbot automation with human agent handoff.",
    highlights: ["AI chatbot", "Human agent support", "Conversation workflows"],
    avatar: null
  },
  {
    name: "Gastroenterologist Website",
    logo: "/images/projects/dr-nisharg-patel.png",
    industry: "Gastroenterologist Website",
    contact: "Dr Nisharg Patel",
    location: "Surat, India",
    relationship: "SaaS Client",
    website: "https://drnishargpatelgastro.com/",
    image: "/images/clients/nisharg.png",
    imagePosition: "center 18%",
    testimonial: "A gastroenterologist website for Dr Nisharg Patel, a senior and respected gastro and liver specialist in Surat. Built using Astro 6 and Codex; web design and SEO are provided by Dr Nisharg Patel's design team, while web development and hosting are done by Globistaan.",
    highlights: ["Astro 6", "Codex", "Development & hosting"],
    avatar: null
  },
  {
    name: "Balaji Print Media",
    logo: "/images/projects/balaji-print-media.png",
    industry: "E-Commerce / Print Media",
    contact: "Mr. Rakesh Garg",
    location: "Chandigarh, India",
    relationship: "SaaS Client",
    website: "https://shop.balajiprintmedia.com/",
    image: "/images/clients/balaji.png",
    imageFit: "contain",
    testimonial: "An e-commerce storefront for Balaji Print Media, focused on premium quality products and a simple online shopping experience.",
    highlights: ["Online storefront", "Product catalog", "Print media commerce"],
    avatar: null
  },
  {
    name: "Sri Krishna Art",
    logo: "/images/projects/sri-krishna-art.jpg",
    industry: "Art Education & Commissions",
    contact: "Greeshma Bhat",
    location: "Bengaluru, India",
    relationship: "SaaS Client",
    website: "https://srikrishnaartt.com/",
    image: "https://srikrishnaartt.com/images/logo.jpg",
    imageFit: "contain",
    testimonial: "Globistaan built and maintains our artist portfolio, class enrolment, commission enquiry, and gallery experience for students, parents, and art collectors.",
    highlights: ["Artist portfolio", "Online classes", "Commissions"],
    avatar: null
  }
];

export const investmentHighlights = [
  { title: "Growing AI Market", description: "The global AI market is projected to reach $1.8 trillion by 2030. Globistaan is positioned at the intersection of AI services and SaaS platforms.", metric: "$1.8T", metricLabel: "AI Market by 2030", icon: TrendingUp },
  { title: "Cost Advantage", description: "Based in Himachal Pradesh, India, we offer world-class AI engineering at highly competitive rates compared to Western markets.", metric: "60%", metricLabel: "Cost Savings", icon: Target },
  { title: "Diversified Portfolio", description: "Four distinct product lines across healthcare, education, commerce, and enterprise AI — reducing single-market dependency.", metric: "4", metricLabel: "Product Lines", icon: Layers },
  { title: "Regulatory Compliance", description: "Fully registered with MCA, GST, MSME, DGFT, and DPIIT — providing investor confidence and operational transparency.", metric: "5+", metricLabel: "Registrations", icon: Shield }
];

export const investmentTiers = [
  { tier: "Seed", range: "Open to discussion", equity: "Case-by-case", benefits: ["Board observer seat", "Quarterly reports", "Product early access"], highlighted: false },
  { tier: "Growth Partnership", range: "Custom proposal", equity: "Negotiable", benefits: ["Monthly reports", "Strategic input", "Co-development rights"], highlighted: true },
  { tier: "Strategic Partner", range: "Partnership-led", equity: "Flexible structure", benefits: ["Strategic syncs", "Joint ventures", "White-label rights", "Revenue sharing"], highlighted: false }
];

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Projects", path: "/projects" },
  { label: "People", path: "/people" },
  { label: "Tech Stack", path: "/tech-stack" },
  { label: "Investors", path: "/investors" },
  { label: "Marketing", path: "/marketing" },
  { label: "Contact", path: "/contact" }
];
